<div class="secondary-guest">
  <mat-accordion multi="true" class="secondary-guest-accordian">
    <mat-expansion-panel [expanded]="true" hideToggle>
      <mat-expansion-panel-header>
        <div class="pt-4 mx-2 d-flex flex-row justify-content-between">
          <label class="seat-header-two w-100 rs-pb-10">{{'additionalGuest' | translate}}
          {{secondaryGuestCount}}</label>
          <div class="secondary-guest-delete pe-4"
            (click)="$event.stopPropagation();deleteSecondary(secondaryGuestDetail)">
            <mat-icon matTooltip="{{'Delete' | translate}}">
              <mat-icon>delete</mat-icon>
            </mat-icon>
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="secondary-guest-section">
            <span *ngIf="stayGuestList?.length > 0 && (this.guestService.operation == 2 || (this.guestService.operation == 0 && isNewGuest))" style="display: inline-flex; justify-content: flex-end; width: 100%;">
           <mat-form-field class="px-2 col-sm-4 col-6" class="seating-fields" style="width: auto; min-width: 200px;"
                   appearance="outline">
                   <mat-label>{{'selectGuest' | translate}}</mat-label>
                   <mat-select [(ngModel)]="SelectedGuestToFillIn" name="stayGuest"
                     placeholder="{{'selectSeatingArea' | translate}}"
                     (ngModelChange)="SelectedGuestToFillInChangeHandler()">
                     <mat-option [value]="Guest" *ngFor="let Guest of stayGuestList;">{{Guest.Name}}
                     </mat-option>
                   </mat-select>
                 </mat-form-field>
                </span>
        <dynamic-form  [ngClass]="{'alias-name' : !guestService.widgetSettings?.ShowAliasName}" [config]="secondaryGuestConfig" #form="dynamicForm">
        </dynamic-form>
      </div>
      <div class="notes-section" *ngIf="showPerferenceNotes">
        <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<ng-template #notesDisplayContent>
  @if (secondaryGuestVisibileFields?.showNotes) {
    @for (notes of notesData; track notes) {
      @if (notes.text) {
        <div class="activity-description-bolder text-uppercase">
          {{notes.text}}
        </div>
      }
      <div class="d-flex flex-row">
        <mat-chip-listbox multiple>
          @for (option of notes.checkBoxOptions; track option) {
            <mat-chip-option class="cursor"
              [selected]="option.selected" [value]="option.value" (click)="toggleSelection(option)" [matTooltip]="option.value" matTooltipPosition="above">
              <!-- @if (option.selected) {
                <mat-icon class="chip-check-icon">check</mat-icon>
              } -->
              <span>{{option.value}}</span>
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
      @if (notes.commentsBox?.id) {
        <div class="pt-3 d-flex flex-row">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{'leaveaComment' | translate}}</mat-label>
            <textarea [(ngModel)]="notes.commentsBox.value" matInput (ngModelChange)="getSecondaryGuestDetails()"
            placeholder="{{'addCommentsHere' | translate}}"></textarea>
          </mat-form-field>
        </div>
      }
    }
  }
</ng-template>